<div class="auth" [class.auth--branded]="branded()" [class.auth--animated]="animated()">
  <aside class="auth__panel">
    @if (imageUrl(); as url) {
      <img class="auth__photo" [src]="url" alt="" aria-hidden="true" />
      <div class="auth__scrim" aria-hidden="true"></div>
    }

    <div class="auth__panelbody">
      <span class="auth__wordmark">
        <img src="/assets/brand/davaco.svg" alt="" aria-hidden="true" />
        Davaco Platform
      </span>

      <!-- Only when there is NO photograph. `.auth__panelbody` sits above the
           photo and its scrim, so rendering both put the drawing ON the
           photograph — a mixed panel, and the exact opposite of the override
           this component documents. -->
      @if (imageUrl() === null) {
        <div class="auth__art">
          <app-auth-art [name]="art()" [animated]="animated()" />
        </div>
      }

      <div class="auth__say">
        @if (headline() !== '') {
          <div class="auth__rule" aria-hidden="true"></div>
          <h2 class="auth__headline">{{ headline() }}</h2>
        }
        @if (blurb() !== '') {
          <p class="auth__blurb">{{ blurb() }}</p>
        }
        @if (tags().length > 0) {
          <span class="auth__tags">
            @for (tag of tags(); track tag) {
              <span class="auth__tag">{{ tag }}</span>
            }
          </span>
        }
      </div>
    </div>

    <!-- The curve into the form column. Decorative and outside the flow so it
         cannot affect the panel's own layout. -->
    <div class="auth__curve" aria-hidden="true"></div>
  </aside>

  <main class="auth__column">
    <div class="auth__form">
      <ng-content />
    </div>
    <div class="auth__legal">
      <span>Terms of use</span>
      <span>Privacy &amp; cookies</span>
      <span>Accessibility</span>
    </div>
  </main>
</div>
